const TRUE_VALUES = ["true", "1", "yes", "enabled", "active"];
const ADMIN_USER_FIELDS = ["id", "_id", "email", "username", "name"];

export function getAdminUsersFromResponse(response) {
  const usersAdminPayload =
    response?.data?.data?.users_admin;

  return normalizeUsersAdminPayload(usersAdminPayload);
}

export function hasUsersAdminPayload(response) {
  return (
    hasOwnProperty(response?.data?.data, "users_admin") ||
    hasOwnProperty(response?.data, "users_admin")
  );
}

export function normalizeAdminUserRow(user, index) {
  return {
    id: getFirstDefinedValue(user?.id, user?._id, index + 1),
    email: getFirstDefinedValue(user?.email),
    password: getFirstDefinedValue(user?.password),
    username: getFirstDefinedValue(user?.username, user?.name),
    enable: normalizeBoolean(
      getFirstDefinedValue(user?.enable, user?.enabled, user?.active)
    ),
    super: normalizeBoolean(
      getFirstDefinedValue(
        user?.super,
        user?.is_super,
        user?.isSuper,
        user?.superadmin,
        user?.super_admin
      )
    ),
  };
}

export function filterAdministrationRows(rows, searchValue) {
  const normalizedSearch = searchValue.trim().toLowerCase();

  if (!normalizedSearch) return rows;

  return rows.filter((row) =>
    [row.id, row.email, row.username]
      .map((value) => String(value ?? "").toLowerCase())
      .some((value) => value.includes(normalizedSearch))
  );
}

export function buildCreateUserPayload(form) {
  return {
    ...(form.id ? { id: form.id } : {}),
    email: String(form.email || "").trim(),
    password: String(form.password || ""),
    username: String(form.username || "").trim(),
    enable: Boolean(form.enable),
    super: Boolean(form.super),
  };
}

export function getApiMessage(response, fallbackMessage) {
  return (
    response?.data?.message ??
    response?.data?.data?.message ??
    fallbackMessage
  );
}

export function getUserDisplayName(user) {
  return (
    String(user?.username ?? "").trim() ||
    String(user?.email ?? "").trim() ||
    String(user?.id ?? "").trim()
  );
}


function normalizeUsersAdminPayload(payload) {
  if (Array.isArray(payload)) return payload;
  if (!payload || typeof payload !== "object") return [];

  if (isAdminUser(payload)) return [payload];

  return Object.values(payload).flatMap(normalizeUsersAdminPayload);
}

function isAdminUser(value) {
  if (!value || typeof value !== "object") return false;

  return ADMIN_USER_FIELDS.some((field) => hasOwnProperty(value, field));
}

function normalizeBoolean(value) {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;

  const normalizedValue = String(value ?? "").trim().toLowerCase();

  return TRUE_VALUES.includes(normalizedValue);
}

function getFirstDefinedValue(...values) {
  return values.find((value) => value !== undefined && value !== null) ?? "";
}

function hasOwnProperty(value, property) {
  return Boolean(value) && Object.prototype.hasOwnProperty.call(value, property);
}
